import { useEffect } from "react";
import { Loader2 } from "lucide-react";

export default function GoogleAuthSuccess() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get("token");

    if (token) {
      localStorage.setItem("commonqr_token", token);
      window.location.replace("/dashboard");
    } else {
      window.location.replace("/login?error=google_failed");
    }
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      <Loader2 className="w-12 h-12 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground font-medium">Signing you in with Google...</p>
    </div>
  );
}
